import type { ChatMessage } from "../types";
import { AIChatAssistantFrame } from "./AIChatAssistantFrame";
import { AIChatDownloadAttachment } from "./AIChatDownloadAttachment";

type Props = {
  message: ChatMessage;
};

export function AIChatDownloadMessage({ message }: Props) {
  return (
    <AIChatAssistantFrame message={message}>
      {message.text ? (
        <p className="text-sm leading-6 text-[#374151]">{message.text}</p>
      ) : null}
      {message.attachment ? (
        <AIChatDownloadAttachment attachment={message.attachment} />
      ) : null}
    </AIChatAssistantFrame>
  );
}
